import { render, staticRenderFns } from "./AscDataCell.vue?vue&type=template&id=0fae2805&"
import script from "./AscDataCell.vue?vue&type=script&lang=js&"
export * from "./AscDataCell.vue?vue&type=script&lang=js&"
import style0 from "./AscDataCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports